import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Gift, ExternalLink } from 'lucide-react';
import { weddingData } from '../data';
import gift from '../assets/gift_bg.jpeg';

export const GiftRegistrySection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section ref={ref} className="relative py-20 md:py-40 px-6 bg-white overflow-hidden" data-testid="gift-registry-section">
      {/* Background gift illustration */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <img
          src={gift}
          alt=""
          className="w-[500px] md:w-[600px] opacity-[0.15]"
        />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        className="max-w-2xl mx-auto text-center"
      >
        <div className="flex items-center justify-center gap-4 mb-8 md:mb-10">
          <div className="h-px w-12 bg-stone-300"></div>
          <p className="text-xs uppercase tracking-widest text-stone-400">Gift Registry</p>
          <div className="h-px w-12 bg-stone-300"></div>
        </div>

        <Gift className="w-8 h-8 md:w-10 md:h-10 text-stone-300 mx-auto mb-6" strokeWidth={1.2} />

        <h2 className="font-elegant text-3xl md:text-5xl lg:text-6xl text-stone-900 mb-6 leading-tight">
          Your presence is the greatest gift.
        </h2>

        <p className="text-base md:text-lg text-stone-500 font-light leading-relaxed mb-12 max-w-lg mx-auto">
          But if you'd like to celebrate with a gift, we've put together a small registry of things we'd love for our new home together.
        </p>

        <a
          href={weddingData.rsvp.registryUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="registry-link-btn"
          className="inline-flex items-center gap-3 px-10 py-4 bg-stone-900 text-white hover:bg-stone-800 transition-all duration-300 font-light uppercase tracking-widest text-xs md:text-sm"
        >
          <ExternalLink className="w-4 h-4" />
          View Our Registry
        </a>

        <div className="flex items-center justify-center pt-12">
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-stone-200 to-transparent"></div>
        </div>
      </motion.div>
    </section>
  );
};
